export var EOutcomeType;
(function (EOutcomeType) {
    EOutcomeType["ThankYou"] = "ThankYou";
    EOutcomeType["Product"] = "Product";
    EOutcomeType["Redirect"] = "Redirect";
})(EOutcomeType || (EOutcomeType = {}));
export var TimeType;
(function (TimeType) {
    TimeType["Question"] = "Question";
    TimeType["Morning"] = "Morning";
    TimeType["Afternoon"] = "Afternoon";
    TimeType["Evening"] = "Evening";
})(TimeType || (TimeType = {}));
export var EPaymentState;
(function (EPaymentState) {
    EPaymentState["Scheduling"] = "Scheduling";
    EPaymentState["Payment"] = "Payment";
    EPaymentState["Success"] = "Success";
})(EPaymentState || (EPaymentState = {}));
